import { render } from "./ApprovalNewDealCreationTable.vue?vue&type=template&id=6d7cc180&scoped=true"
import script from "./ApprovalNewDealCreationTable.vue?vue&type=script&lang=js"
export * from "./ApprovalNewDealCreationTable.vue?vue&type=script&lang=js"

import "./ApprovalNewDealCreationTable.vue?vue&type=style&index=0&id=6d7cc180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7cc180"]])

export default __exports__